import RadioGroupBox from './radiogroupbox.vue';
export {RadioGroupBox};


// WEBPACK FOOTER //
// ./src/components/radiobox/index.js